import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { COMPANY } from '../../lib/site';
/** Floating 3D-feel shield with rotating energy ring, water waves, and a rotating flame. */
export function ShieldEmblem() {
  return <div className="relative mx-auto flex h-[380px] w-[380px] items-center justify-center sm:h-[460px] sm:w-[460px]" data-id="element-386" data-mp="238aiduf29woz">
      {/* glow */}
      <div className="absolute h-64 w-64 rounded-full bg-[radial-gradient(circle,rgba(45,168,255,0.35),transparent_70%)] blur-2xl" data-id="element-387" data-mp="2vzkhu8h7hztq" />

      {/* rotating energy ring */}
      <motion.div className="absolute h-[340px] w-[340px] rounded-full border-2 border-dashed border-electric/40 sm:h-[400px] sm:w-[400px]" animate={{
      rotate: 360
    }} transition={{
      duration: 22,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-388" data-mp="2qy4z4n2i45ei" />
      <motion.div className="absolute h-[280px] w-[280px] rounded-full border border-royal/30 sm:h-[330px] sm:w-[330px]" animate={{
      rotate: -360
    }} transition={{
      duration: 30,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-389" data-mp="16kcr10i6cbmf">
        <span className="absolute -top-1.5 left-1/2 h-3 w-3 -translate-x-1/2 rounded-full bg-electric shadow-[0_0_12px_rgba(45,168,255,0.9)]" data-id="element-390" data-mp="2cpus6h1h2jgw" />
      </motion.div>

      {/* water wave arcs */}
      <svg className="absolute h-[300px] w-[300px] sm:h-[360px] sm:w-[360px]" viewBox="0 0 200 200" fill="none" data-id="element-391" data-mp="22zs1wolqjjm9">
        <motion.circle cx="100" cy="100" r="86" stroke="rgba(0,87,255,0.25)" strokeWidth="1.5" strokeDasharray="10 18" animate={{
        rotate: 360
      }} transition={{
        duration: 18,
        repeat: Infinity,
        ease: 'linear'
      }} style={{
        transformOrigin: 'center'
      }} data-id="element-392" data-mp="27rtbg2riqw8l" />
      </svg>

      {/* floating shield */}
      <motion.div className="relative z-10" animate={{
      y: [0, -14, 0]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-393" data-mp="3qpy7o58ts2pa">
        <div className="rounded-[2.5rem] bg-white/60 p-8 shadow-glow backdrop-blur-xl border border-white/70" data-id="element-394" data-mp="3gzd0vuizzrva">
          <img src={COMPANY.logo} alt="Dream Shield emblem" decoding="async" className="h-52 w-52 object-contain sm:h-60 sm:w-60" style={{
          filter: 'drop-shadow(0 12px 28px rgba(0,87,255,0.25))'
        }} data-id="element-395" data-mp="3cvf59tsvsz6z" />
        </div>
      </motion.div>

      {/* rotating flame accent */}
      <motion.div className="absolute right-8 top-16 z-20 flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-fire" animate={{
      y: [0, -10, 0],
      rotate: [0, 8, -8, 0]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-396" data-mp="3vn7wpjsayccl">
        <FlameIcon className="h-5 w-5 text-fire" fill="#FF5A36" strokeWidth={1.5} data-id="element-397" data-mp="14pmzek2zb196" />
      </motion.div>

      {/* floating water droplet */}
      <motion.div className="absolute bottom-14 left-6 z-20 flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-glow-sm" animate={{
      y: [0, 12, 0]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-398" data-mp="18pdomjcux9bl">
        <span className="h-3 w-3 rounded-full bg-electric" data-id="element-399" data-mp="1sfqshxijjilx" />
      </motion.div>
    </div>;
}